
import React, { useState, useEffect } from "react";
import Sidebar from "../../Components/Sidebar";
import TopNav from "../../Components/TopNav";
import {
  getPremiumCustomerListServ,
  deletePremiumCustomerServ,
  exportPremiumCustomerServ,
} from "../../services/premiumCustomer.service";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { triggerFileDownload } from "../../utils/fileDownload";
import NoRecordFound from "../../Components/NoRecordFound";
import { IMAGE_BASE_URL } from "../../utils/api_base_url_configration";


/* ─── Scoped styles ─────────────────────────────────── */
const styles = `
  .pc-page {
    background: #f5f5f7;
    min-height: 100%;
    padding: 28px;
    font-family: 'Segoe UI', sans-serif;
  }

  /* stat grid */
  .pc-stat-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 14px;
    margin-bottom: 20px;
  }
  @media (max-width: 900px) { .pc-stat-grid { grid-template-columns: repeat(2, 1fr); } }
  @media (max-width: 560px) { .pc-stat-grid { grid-template-columns: 1fr; } }

  .pc-stat-card {
    background: #fff;
    border-radius: 14px;
    padding: 18px 20px;
    border: 1px solid #f0eded;
    display: flex;
    align-items: center;
    gap: 14px;
  }
  .pc-stat-icon {
    width: 44px; height: 44px;
    border-radius: 11px;
    background: #fdf2f1;
    display: flex; align-items: center; justify-content: center;
    font-size: 20px;
    color: #a32d2d;
    flex-shrink: 0;
  }
  .pc-stat-val {
    font-size: 26px;
    font-weight: 700;
    color: #1c0a0a;
    line-height: 1;
  }
  .pc-stat-lbl {
    font-size: 13px;
    color: #828282;
    margin-top: 4px;
  }

  /* toolbar */
  .pc-toolbar {
    background: #fff;
    border-radius: 14px;
    padding: 16px 20px;
    border: 1px solid #f0eded;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 16px;
  }
  .pc-toolbar-title {
    font-size: 18px;
    font-weight: 700;
    color: #1c0a0a;
  }
  .pc-toolbar-right {
    display: flex; align-items: center; gap: 10px; flex-wrap: wrap;
  }
  .pc-input {
    height: 40px;
    border-radius: 10px;
    border: 1px solid #f0eded;
    padding: 0 14px;
    font-size: 13px;
    color: #555;
    background: #f9f9f9;
    outline: none;
    width: 260px;
  }
  .pc-input:focus { border-color: #f0c0b8; }

  .pc-btn-red {
    height: 40px;
    padding: 0 20px;
    border-radius: 10px;
    background: #a60808;
    color: #fff;
    border: none;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    display: flex; align-items: center; gap: 7px;
    white-space: nowrap;
  }
  .pc-btn-red:hover { background: #a93226; }
  .pc-btn-red i { font-size: 15px; }

  /* download dropdown */
  .pc-download-wrap { position: relative; }
  .pc-dropdown-menu {
    position: absolute;
    top: calc(100% + 6px);
    right: 0;
    background: #fff;
    border: 1px solid #f0eded;
    border-radius: 10px;
    padding: 6px;
    z-index: 100;
    min-width: 175px;
    box-shadow: 0 4px 16px rgba(0,0,0,0.08);
  }
  .pc-dropdown-item {
    display: block; width: 100%;
    padding: 9px 14px;
    font-size: 13px; color: #444;
    background: none; border: none;
    border-radius: 7px;
    text-align: left; cursor: pointer;
  }
  .pc-dropdown-item:hover { background: #fdf2f1; color: #a60808; }

  /* table */
  .pc-table-wrap {
    background: #fff;
    border-radius: 14px;
    border: 1px solid #f0eded;
    overflow: hidden;
  }
  .pc-table-scroll { overflow-x: auto; }
  .pc-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13.5px;
  }
  .pc-table thead tr { background: #fdf2f1; }
  .pc-table th {
    padding: 14px 16px;
    text-align: left;
    font-size: 11.5px;
    font-weight: 700;
    color: #a60808;
    text-transform: uppercase;
    letter-spacing: 0.6px;
    white-space: nowrap;
  }
  .pc-table td {
    padding: 14px 16px;
    color: #444;
    border-top: 1px solid #f7f5f5;
    vertical-align: middle;
  }
  .pc-table tbody tr:hover td { background: #fdfafa; }

  /* avatar cell */
  .pc-av-cell { display: flex; align-items: center; gap: 10px; }
  .pc-av {
    width: 36px; height: 36px;
    border-radius: 50%;
    background: #fdf2f1;
    display: flex; align-items: center; justify-content: center;
    font-size: 12px; font-weight: 700; color: #a60808;
    flex-shrink: 0;
  }
  .pc-av-name { font-size: 15px; color: #333; font-weight: 600; }
  .pc-av-email { font-size: 12px; color: #bbb; margin-top: 2px; }

  .pc-phone { font-size: 14px; color: #666; font-family: monospace; }

  /* premium badge */
  .pc-badge-premium {
    display: inline-flex; align-items: center; gap: 5px;
    padding: 4px 12px;
    border-radius: 20px;
    background: #eaf3de;
    color: #27500a;
    font-size: 12px; font-weight: 600;
  }
  .pc-badge-premium i { font-size: 12px; }

  /* action buttons */
  .pc-view-btn {
    height: 34px; padding: 0 14px;
    border-radius: 9px;
    border: 1px solid #f0eded;
    background: #fff;
    font-size: 13px; color: #555;
    cursor: pointer;
    display: inline-flex; align-items: center; gap: 5px;
    transition: all 0.18s;
    margin-right: 6px;
  }
  .pc-view-btn:hover { background: #fdf2f1; border-color: #f0c0b8; color: #a60808; }
  .pc-view-btn i { font-size: 14px; }

  .pc-del-btn {
    height: 34px; padding: 0 14px;
    border-radius: 9px;
    border: 1px solid #fcc;
    background: #fff;
    font-size: 13px; color: #a60808;
    cursor: pointer;
    display: inline-flex; align-items: center; gap: 5px;
    transition: all 0.18s;
  }
  .pc-del-btn:hover { background: #fdf2f1; }
  .pc-del-btn i { font-size: 14px; }

  /* pagination */
  .pc-pagination {
    display: flex; align-items: center;
    justify-content: space-between;
    flex-wrap: wrap; gap: 12px;
    padding: 16px 20px;
    border-top: 1px solid #f7f5f5;
  }
  .pc-show-row { display: flex; align-items: center; gap: 8px; font-size: 13px; color: #888; }
  .pc-select {
    height: 34px;
    border-radius: 9px;
    border: 1px solid #f0eded;
    padding: 0 10px;
    font-size: 13px; color: #555;
    background: #f9f9f9; outline: none;
  }
  .pc-pg-btns { display: flex; align-items: center; gap: 5px; }
  .pc-pg-btn {
    width: 34px; height: 34px;
    border-radius: 9px;
    border: 1px solid #f0eded;
    background: #fff;
    font-size: 13px; color: #555;
    cursor: pointer;
    display: flex; align-items: center; justify-content: center;
    transition: all 0.18s;
  }
  .pc-pg-btn.active { background: #a60808; color: #fff; border-color: #a60808; }
  .pc-pg-btn:hover:not(.active):not(:disabled) { background: #fdf2f1; color: #a60808; }
  .pc-pg-btn:disabled { opacity: 0.4; cursor: default; }

  /* modal */
  .pc-modal-overlay {
    position: fixed; inset: 0;
    background: rgba(0,0,0,0.45);
    display: flex; align-items: center; justify-content: center;
    z-index: 1050;
  }
  .pc-modal {
    background: #fff;
    border-radius: 18px;
    width: 100%; max-width: 540px;
    max-height: 85vh; overflow-y: auto;
    box-shadow: 0 16px 48px rgba(0,0,0,0.14);
  }
  .pc-modal-header {
    display: flex; align-items: center;
    justify-content: space-between;
    padding: 22px 26px 16px;
    border-bottom: 1px solid #f0eded;
  }
  .pc-modal-title {
    font-size: 16px; font-weight: 700; color: #1c0a0a;
  }
  .pc-modal-close {
    width: 32px; height: 32px;
    border-radius: 8px;
    border: 1px solid #f0eded;
    background: none; cursor: pointer;
    display: flex; align-items: center; justify-content: center;
    color: #888; font-size: 16px;
  }
  .pc-modal-close:hover { background: #fdf2f1; color: #a60808; }
  .pc-modal-body { padding: 22px 26px; }
  .pc-modal-sec-title {
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.7px;
    color: #a60808;
    font-weight: 700;
    margin-bottom: 10px;
  }
  .pc-modal-row {
    display: flex; justify-content: space-between;
    padding: 9px 0;
    border-bottom: 1px solid #f7f5f5;
    font-size: 13.5px;
  }
  .pc-modal-row:last-child { border-bottom: none; }
  .pc-modal-key { color: #999; }
  .pc-modal-val { color: #333; font-weight: 600; text-align: right; }
  .pc-modal-footer {
    padding: 16px 26px;
    border-top: 1px solid #f0eded;
    display: flex; justify-content: flex-end;
  }
  .pc-modal-close-btn {
    height: 38px; padding: 0 22px;
    border-radius: 9px;
    border: 1px solid #f0eded;
    background: #f9f9f9;
    font-size: 13px; color: #555;
    cursor: pointer;
  }
  .pc-modal-close-btn:hover { background: #fdf2f1; }

  .pc-prod-item {
    display: flex; align-items: center; gap: 12px;
    padding: 10px 0;
    border-bottom: 1px solid #f7f5f5;
  }
  .pc-prod-img {
    width: 56px; height: 56px;
    border-radius: 8px;
    object-fit: cover;
    border: 1px solid #f0eded;
  }
  .pc-status-pill {
    display: inline-flex; align-items: center;
    padding: 4px 10px;
    border-radius: 20px;
    font-size: 12px; font-weight: 600;
  }
`;

function PremiumCustomerList() {

   const getImageUrl = (image) => {
          if (!image) return "";
          if (image.startsWith("http")) return image;
          return `${IMAGE_BASE_URL}${image}`;
        };
      

  const [list, setList] = useState([]);
  const [statics, setStatics] = useState(null);
  const [payload, setPayload] = useState({
    searchKey: "",
    pageNo: 1,
    pageCount: 10,
    sortByField: "",
  });
  const [showSkelton, setShowSkelton] = useState(false);
  const [totalPages, setTotalPages] = useState(1);
  const [selectedUser, setSelectedUser] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showDownloadMenu, setShowDownloadMenu] = useState(false);

  const handleViewUser = (user) => {
    setSelectedUser(user);
    setShowModal(true);
  };

  const handleGetPremiumCustomers = async () => {
    if (list.length === 0) setShowSkelton(true);
    try {
      let response = await getPremiumCustomerListServ(payload);
      setList(response?.data?.data);
      setStatics(response?.data?.documentCount);
    } catch (error) {
      toast.error("Failed to fetch premium customers");
    }
    setShowSkelton(false);
  };

  const handleDeletePremiumCustomer = async (id) => {
    const confirmed = window.confirm(
      "Are you sure you want to delete this premium customer?"
    );
    if (confirmed) {
      try {
        let response = await deletePremiumCustomerServ(id);
        if (response?.data?.statusCode === "200") {
          toast.success(response?.data?.message);
          handleGetPremiumCustomers();
        }
      } catch (error) {
        toast.error(error?.response?.data?.message || "Internal Server Error");
      }
    }
  };

  useEffect(() => {
    handleGetPremiumCustomers();
  }, [payload]);

  useEffect(() => {
    if (statics?.totalCount && payload.pageCount) {
      setTotalPages(Math.ceil(statics.totalCount / payload.pageCount));
    }
  }, [statics, payload.pageCount]);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setPayload({ ...payload, pageNo: newPage });
    }
  };

  const handleDownload = async (format) => {
    setShowDownloadMenu(false);
    try {
      const response = await exportPremiumCustomerServ(payload, format);
      const ext = format === "excel" ? "xlsx" : format;
      triggerFileDownload(response.data, `premiumCustomers.${ext}`);
    } catch (err) {
      toast.error("Download failed");
    }
  };

  const getInitials = (user) => {
    const f = user?.userId?.firstName?.[0] || "";
    const l = user?.userId?.lastName?.[0] || "";
    return (f + l).toUpperCase() || "U";
  };

  const getStatusStyle = (status) => {
    switch (status) {
      case "completed":   return { background: "#eaf3de", color: "#27500a" };
      case "outForDelivery": return { background: "#e6f1fb", color: "#0c447c" };
      case "orderPacked": return { background: "#faeeda", color: "#633806" };
      case "cancelled":   return { background: "#fcebeb", color: "#791f1f" };
      default:            return { background: "#f0eded", color: "#555" };
    }
  };

  const getStatusLabel = (status) => {
    const map = {
      pending: "Order Received",
      paymentSsUpload: "Payment Uploaded",
      orderPlaced: "Payment Confirmed",
      orderPacked: "Order Packed",
      outForDelivery: "Dispatched",
      completed: "Completed",
      cancelled: "Cancelled",
    };
    return map[status] || status;
  };

  return (
    <div className="bodyContainer">
      <style>{styles}</style>
      <Sidebar selectedMenu="User Management" selectedItem="Premium Customer" />
      <div className="mainContainer">
        <TopNav pageTitle="Premium Customers" pagePath="Home / User Management / Premium Customer" />
        <div className="pc-page">

          {/* ── Stat Cards ── */}
          <div className="pc-stat-grid">
            <div className="pc-stat-card">
              <div className="pc-stat-icon">
                <i className="ti ti-crown" aria-hidden="true" />
              </div>
              <div>
                <div className="pc-stat-val">{statics?.totalCount ?? "—"}</div>
                <div className="pc-stat-lbl">Total premium users</div>
              </div>
            </div>
            {/* <div className="pc-stat-card">
              <div className="pc-stat-icon" style={{ background: "#e6f1fb", color: "#185fa5" }}>
                <i className="ti ti-user-check" aria-hidden="true" />
              </div>
              <div>
                <div className="pc-stat-val">{statics?.activeCount ?? "—"}</div>
                <div className="pc-stat-lbl">Active subscribers</div>
              </div>
            </div>
            <div className="pc-stat-card">
              <div className="pc-stat-icon" style={{ background: "#eaf3de", color: "#3b6d11" }}>
                <i className="ti ti-shopping-bag" aria-hidden="true" />
              </div>
              <div>
                <div className="pc-stat-val">{statics?.orderCount ?? "—"}</div>
                <div className="pc-stat-lbl">Total orders placed</div>
              </div>
            </div> */}
          </div>

          {/* ── Toolbar ── */}
          <div className="pc-toolbar">
            <div className="pc-toolbar-title">Premium customers</div>
            <div className="pc-toolbar-right">
              <input
                className="pc-input"
                placeholder="Search by name, email or phone"
                onChange={(e) =>
                  setPayload({ ...payload, searchKey: e.target.value, pageNo: 1 })
                }
              />
              <div className="pc-download-wrap">
                <button
                  className="pc-btn-red"
                  onClick={() => setShowDownloadMenu((p) => !p)}
                >
                  <i className="ti ti-download" aria-hidden="true" />
                  Download
                </button>
                {showDownloadMenu && (
                  <div className="pc-dropdown-menu">
                    <button className="pc-dropdown-item" onClick={() => handleDownload("txt")}>
                      <i className="ti ti-file-text" aria-hidden="true" style={{ marginRight: 6 }} />
                      Download as TXT
                    </button>
                    <button className="pc-dropdown-item" onClick={() => handleDownload("excel")}>
                      <i className="ti ti-file-spreadsheet" aria-hidden="true" style={{ marginRight: 6 }} />
                      Download as Excel
                    </button>
                    <button className="pc-dropdown-item" onClick={() => handleDownload("csv")}>
                      <i className="ti ti-file" aria-hidden="true" style={{ marginRight: 6 }} />
                      Download as CSV
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* ── Table ── */}
          <div className="pc-table-wrap">
            <div className="pc-table-scroll">
              <table className="pc-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Customer</th>
                    <th>Phone</th>
                    <th>Premium status</th>
                    {/* <th>Order status</th> */}
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {showSkelton ? (
                    [...Array(10)].map((_, i) => (
                      <tr key={i}>
                        {[...Array(6)].map((__, j) => (
                          <td key={j} style={{ padding: "14px 16px", borderTop: "1px solid #f7f5f5" }}>
                            <Skeleton height={18} />
                          </td>
                        ))}
                      </tr>
                    ))
                  ) : list?.length === 0 ? (
                    <tr>
                      <td colSpan="6" style={{ textAlign: "center", padding: "40px" }}>
                        <NoRecordFound />
                      </td>
                    </tr>
                  ) : (
                    list.map((v, i) => {
                      const ss = getStatusStyle(v?.orderId?.status);
                      return (
                        <tr key={v?._id}>
                          <td style={{ color: "#828282", fontSize: "13px" }}>
                            {(payload.pageNo - 1) * payload.pageCount + i + 1}
                          </td>
                          <td>
                            <div className="pc-av-cell">
                              <div className="pc-av">{getInitials(v)}</div>
                              <div>
                                <div className="pc-av-name">
                                  {v?.userId?.firstName || ""} {v?.userId?.lastName || ""}
                                </div>
                                <div className="pc-av-email">{v?.userId?.email || "-"}</div>
                              </div>
                            </div>
                          </td>
                          <td>
                            <span className="pc-phone">{v?.userId?.phone || "-"}</span>
                          </td>
                          <td>
                            <span className="pc-badge-premium">
                              <i className="ti ti-crown" aria-hidden="true" /> Premium
                            </span>
                          </td>
                          {/* <td>
                            <span
                              className="pc-status-pill"
                              style={{ background: ss.background, color: ss.color }}
                            >
                              {getStatusLabel(v?.orderId?.status)}
                            </span>
                          </td> */}
                          <td>
                            <button
                              className="pc-view-btn"
                              onClick={() => handleViewUser(v)}
                            >
                              <i className="ti ti-eye" aria-hidden="true" /> View
                            </button>
                            <button
                              className="pc-del-btn"
                              onClick={() => handleDeletePremiumCustomer(v?._id)}
                            >
                              <i className="ti ti-trash" aria-hidden="true" /> Delete
                            </button>
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>

            {/* ── Pagination ── */}
            <div className="pc-pagination">
              <div className="pc-show-row">
                Show
                <select
                  className="pc-select"
                  value={payload.pageCount}
                  onChange={(e) =>
                    setPayload({ ...payload, pageCount: parseInt(e.target.value), pageNo: 1 })
                  }
                >
                  {[10, 25, 50, 100].map((v) => (
                    <option key={v} value={v}>{v}</option>
                  ))}
                </select>
                entries
              </div>
              <div className="pc-pg-btns">
                <button
                  className="pc-pg-btn"
                  disabled={payload.pageNo === 1}
                  onClick={() => handlePageChange(payload.pageNo - 1)}
                >
                  <i className="ti ti-chevron-left" style={{ fontSize: "13px" }} />
                </button>
                {[...Array(totalPages)].map((_, i) => {
                  const page = i + 1;
                  if (
                    page === 1 ||
                    page === totalPages ||
                    (page >= payload.pageNo - 1 && page <= payload.pageNo + 1)
                  ) {
                    return (
                      <button
                        key={page}
                        className={`pc-pg-btn ${payload.pageNo === page ? "active" : ""}`}
                        onClick={() => handlePageChange(page)}
                      >
                        {page}
                      </button>
                    );
                  } else if (
                    (page === payload.pageNo - 2 && page > 2) ||
                    (page === payload.pageNo + 2 && page < totalPages - 1)
                  ) {
                    return (
                      <button key={page} className="pc-pg-btn" disabled>...</button>
                    );
                  }
                  return null;
                })}
                <button
                  className="pc-pg-btn"
                  disabled={payload.pageNo === totalPages}
                  onClick={() => handlePageChange(payload.pageNo + 1)}
                >
                  <i className="ti ti-chevron-right" style={{ fontSize: "13px" }} />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ── Detail Modal ── */}
      {showModal && selectedUser && (
        <div className="pc-modal-overlay">
          <div className="pc-modal">
            <div className="pc-modal-header">
              <div className="pc-modal-title">Customer details</div>
              <button className="pc-modal-close" onClick={() => setShowModal(false)}>
                <i className="ti ti-x" style={{ fontSize: "15px" }} aria-hidden="true" />
              </button>
            </div>
            <div className="pc-modal-body">

              {/* Avatar header */}
              <div style={{ display: "flex", alignItems: "center", gap: "14px", marginBottom: "20px", paddingBottom: "18px", borderBottom: "1px solid #f0eded" }}>
                <div className="pc-av" style={{ width: "52px", height: "52px", fontSize: "17px", flexShrink: 0 }}>
                  {getInitials(selectedUser)}
                </div>
                <div>
                  <div style={{ fontSize: "16px", fontWeight: 700, color: "#1c0a0a" }}>
                    {selectedUser?.userId?.firstName} {selectedUser?.userId?.lastName}
                  </div>
                  <div style={{ fontSize: "13px", color: "#828282", marginTop: "3px" }}>
                    {selectedUser?.userId?.email}
                  </div>
                </div>
              </div>

              {/* User info */}
              <div style={{ marginBottom: "18px" }}>
                <div className="pc-modal-sec-title">User info</div>
                <div className="pc-modal-row">
                  <span className="pc-modal-key">Phone</span>
                  <span className="pc-modal-val" style={{ fontFamily: "monospace" }}>{selectedUser?.userId?.phone || "-"}</span>
                </div>
                <div className="pc-modal-row">
                  <span className="pc-modal-key">Email</span>
                  <span className="pc-modal-val">{selectedUser?.userId?.email || "-"}</span>
                </div>
              </div>

              {/* Order info */}
              <div style={{ marginBottom: "18px" }}>
                <div className="pc-modal-sec-title">Order info</div>
                <div className="pc-modal-row">
                  <span className="pc-modal-key">Order ID</span>
                  <span className="pc-modal-val" style={{ fontFamily: "monospace" }}>#{selectedUser?.orderId?._id?.slice(-8) || "N/A"}</span>
                </div>
                <div className="pc-modal-row">
                  <span className="pc-modal-key">Total amount</span>
                  <span className="pc-modal-val">Rs {selectedUser?.orderId?.totalAmount?.toLocaleString()}</span>
                </div>
                <div className="pc-modal-row">
                  <span className="pc-modal-key">Status</span>
                  <span className="pc-modal-val">
                    <span
                      className="pc-status-pill"
                      style={{
                        ...getStatusStyle(selectedUser?.orderId?.status),
                        fontSize: "12px",
                      }}
                    >
                      {getStatusLabel(selectedUser?.orderId?.status)}
                    </span>
                  </span>
                </div>
              </div>

              {/* Shipping address */}
              <div style={{ marginBottom: "18px" }}>
                <div className="pc-modal-sec-title">Shipping address</div>
                <div className="pc-modal-row">
                  <span className="pc-modal-key">Full name</span>
                  <span className="pc-modal-val">{selectedUser?.orderId?.address?.fullName || "-"}</span>
                </div>
                <div className="pc-modal-row">
                  <span className="pc-modal-key">Phone</span>
                  <span className="pc-modal-val" style={{ fontFamily: "monospace" }}>{selectedUser?.orderId?.address?.phone || "-"}</span>
                </div>
                <div className="pc-modal-row">
                  <span className="pc-modal-key">City</span>
                  <span className="pc-modal-val">{selectedUser?.orderId?.address?.city || "-"}</span>
                </div>
                <div className="pc-modal-row">
                  <span className="pc-modal-key">State</span>
                  <span className="pc-modal-val">{selectedUser?.orderId?.address?.state || "-"}</span>
                </div>
                <div className="pc-modal-row">
                  <span className="pc-modal-key">Pincode</span>
                  <span className="pc-modal-val">{selectedUser?.orderId?.address?.pincode || "-"}</span>
                </div>
              </div>

              {/* Products */}
              {selectedUser?.orderId?.product?.length > 0 && (
                <div style={{ marginBottom: "18px" }}>
                  <div className="pc-modal-sec-title">Products</div>
                  {selectedUser?.orderId?.product?.map((p, idx) => (
                    <div className="pc-prod-item" key={idx}>
                      <img
                      src={getImageUrl(p?.productHeroImage)}
                        alt="product"
                        className="pc-prod-img"
                      />
                      <div>
                        <div style={{ fontSize: "13.5px", fontWeight: 600, color: "#333" }}>
                          Qty: {p?.quantity}
                        </div>
                        <div style={{ fontSize: "13px", color: "#828282", marginTop: "3px" }}>
                          Rs {p?.totalPrice?.toLocaleString()}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {/* Status history */}
              {selectedUser?.orderId?.statusHistory?.length > 0 && (
                <div>
                  <div className="pc-modal-sec-title">Status history</div>
                  {selectedUser?.orderId?.statusHistory?.map((s, idx) => (
                    <div className="pc-modal-row" key={idx}>
                      <span className="pc-modal-key">
                        <span
                          className="pc-status-pill"
                          style={{ ...getStatusStyle(s?.status), fontSize: "11.5px" }}
                        >
                          {getStatusLabel(s?.status)}
                        </span>
                      </span>
                      <span className="pc-modal-val" style={{ fontWeight: 400, color: "#828282", fontSize: "12.5px" }}>
                        {new Date(s?.updatedAt).toLocaleString()}
                      </span>
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div className="pc-modal-footer">
              <button className="pc-modal-close-btn" onClick={() => setShowModal(false)}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default PremiumCustomerList;